import { render, staticRenderFns } from "./HeadFilter.vue?vue&type=template&id=3c36b038&scoped=true&"
import script from "./HeadFilter.vue?vue&type=script&lang=js&"
export * from "./HeadFilter.vue?vue&type=script&lang=js&"
import style0 from "./HeadFilter.vue?vue&type=style&index=0&id=3c36b038&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c36b038",
  null
  
)

export default component.exports